import React, { useEffect, useState } from "react";
import { Button, Input, Select } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { CountryDropdown } from "react-country-region-selector";
import moment from "moment";
import CurrencyDropdown, { getCurrencySymbol } from "../../../components/CurrencyDropdown";

const AddStaff = () => {
  const navigate = useNavigate();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [ship_id, set_ship_id] = useState("");
  const [role_permission_id, set_role_permission_id] = useState("");
  const [first_name, set_first_name] = useState("");
  const [last_name, set_last_name] = useState("");
  const [email, set_email] = useState("");
  const [date_of_birth, set_date_of_birth] = useState("");
  const [password, set_password] = useState("");
  const [confirm_password, set_confirm_password] = useState("");
  const [passport_number, set_passport_number] = useState("");
  const [seafarer_id, set_seafarer_id] = useState("");
  const [nationality, set_nationality] = useState("");
  const [current_address, set_current_address] = useState("");
  const [permanent_address, set_permanent_address] = useState("");
  const [phone_number, set_phone_number] = useState("");
  const [list_roll_permission, set_list_roll_permission] = useState([]);
  const [list_ship, set_list_ship] = useState([]);
  const [country_code, set_country_code] = useState("65");
  const [emergency_contact_name, set_emergency_contact_name] = useState("");
  const [emergency_contact_phone, set_emergency_contact_phone] = useState("");
  const [gender, set_gender] = useState("");
  const [marital_status, set_marital_status] = useState("");
  const [securityCode, setSecurityCode] = useState("");
  const [errorSecurity, setErrorSecurity] = useState("");
  const [base_salary, setBase_salary] = useState(0);
  const [fixed_overtime_hours, setFixed_overtime_hours] = useState(0);
  const [fixed_overtime_pay, setfixed_overtime_pay] = useState(0);
  const [per_hour_overtime_pay, setPer_hour_overtime_pay] = useState(0);
  const [department, setDepartment] = useState("");
  const [signOnDate, setSignOnDate] = useState("");
  const [expectedSignOffDate, setExpectedSignOffDate] = useState("");
  const [actualSignOffDate, setActualSignOffDate] = useState("");
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [dragMode, setDragMode] = useState("add");
  const [activeOvertime, setActiveOvertime] = useState(false);
  const [currency, setCurrency] = useState("USD");

  const clearError = (fieldName) => {
    if (errors[fieldName]) {
      set_errors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  const ListofRollPermissionStaff = () => {
    const FORM_DATA = new FormData();
    post(ApiURL.list_role_permission, FORM_DATA).then((res) => {
      if (res?.status == true) {
        set_list_roll_permission(res?.role_permission);
      } else {
        const errors = res?.errors || {};
        set_errors(errors);
      }
    });
  };

  const ListofShipsPermissionStaff = () => {
    const FORM_DATA = new FormData();
    post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
      if (res?.status == true) {
        set_list_ship(res?.ships);
        ListofRollPermissionStaff();
      } else {
        const errors = res?.errors || {};
        set_errors(errors);
      }
    });
  };

  const toggleSlot = (slot) => {
    setSelectedSlots((prev) => {
      if (prev.includes(slot)) {
        return prev.filter((item) => item !== slot);
      } else {
        return [...prev, slot];
      }
    });
  };

  const handleMouseDown = (slot) => {
    const isSelected = selectedSlots.includes(slot);

    setDragMode(isSelected ? "remove" : "add");
    setIsDragging(true);

    setSelectedSlots((prev) => {
      if (isSelected) {
        return prev.filter((item) => item !== slot);
      }

      return [...prev, slot];
    });
  };

  const handleMouseEnter = (slot) => {
    if (!isDragging) return;

    setSelectedSlots((prev) => {
      const exists = prev.includes(slot);

      if (dragMode === "add") {
        return exists ? prev : [...prev, slot];
      }

      return exists
        ? prev.filter((item) => item !== slot)
        : prev;
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    setDragMode("add");
  };

  const mergeContinuousSlots = (slots) => {
    if (!slots.length) return [];

    const convertToMinutes = (time) => {
      const [hour, minute] = time.split(":").map(Number);
      return hour * 60 + minute;
    };

    const sortedSlots = slots
      .map((slot) => {
        const [start, end] = slot.split("-");
        return {
          start,
          end,
          startMin: convertToMinutes(start),
          endMin: convertToMinutes(end),
        };
      })
      .sort((a, b) => a.startMin - b.startMin);

    const merged = [];
    let current = { ...sortedSlots[0] };

    for (let i = 1; i < sortedSlots.length; i++) {
      const next = sortedSlots[i];

      if (current.endMin === next.startMin) {
        current.end = next.end;
        current.endMin = next.endMin;
      } else {
        merged.push({
          start: current.start,
          end: current.end,
        });
        current = { ...next };
      }
    }

    merged.push({
      start: current.start,
      end: current.end,
    });

    return merged;
  };


  const Add_Ship_Staff = () => {
    // if (!securityCode) {
    //   setErrorSecurity("Security code is required");
    //   return;
    // } else {
    //   setErrorSecurity("");
    // }
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_id);
      FORM_DATA.append("first_name", first_name);
      FORM_DATA.append("last_name", last_name);
      FORM_DATA.append("date_of_birth", date_of_birth || moment(new Date()).format("YYYY-MM-DD"));
      FORM_DATA.append("staff_email", email);
      FORM_DATA.append("staff_password", password);
      FORM_DATA.append("confirm_password", confirm_password);
      FORM_DATA.append("role_permission_id", role_permission_id);
      FORM_DATA.append("phone_number", phone_number);
      FORM_DATA.append("current_address", current_address);
      FORM_DATA.append("permanent_address", permanent_address);
      FORM_DATA.append("country_code", country_code);
      FORM_DATA.append("seafarer_id", seafarer_id);
      FORM_DATA.append("nationality", nationality);
      FORM_DATA.append("overtime_enabled", activeOvertime ? true : false);
      FORM_DATA.append("base_salary", base_salary);
      FORM_DATA.append("fixed_overtime_hours", fixed_overtime_hours);
      FORM_DATA.append("fixed_overtime_wages", fixed_overtime_pay);
      FORM_DATA.append("overtime_wages_per_hour", per_hour_overtime_pay);
      FORM_DATA.append("department", department);
      FORM_DATA.append("currency", currency);
      if (signOnDate) FORM_DATA.append("sign_on_date", signOnDate);
      if (expectedSignOffDate) FORM_DATA.append("expected_sign_off_date", expectedSignOffDate);
      if (actualSignOffDate) FORM_DATA.append("actual_sign_off_date", actualSignOffDate);

      // selected timeline slots
      const mergedSlots = mergeContinuousSlots(selectedSlots);

      FORM_DATA.append(
        "planned_hours",
        JSON.stringify(mergedSlots) || []
      );

      FORM_DATA.append("role", "staff");
      FORM_DATA.append("master_code", securityCode);
      post(ApiURL.staff_registration, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_loader(false);
          SuccessToast("Staff Registartion Success!!", res?.message);
          navigate("/company-staff-list");
        } else {
          set_loader(false);
          const errors = res?.errors || {};
          set_errors(errors);
          ErrorToast("Staff Registartion Error", res?.message);
        }
      });
    } catch (error) {
      ErrorToast("Error Occurred", "There was an error during registration.");
    } finally {
    }
  };

  useEffect(() => {
    ListofShipsPermissionStaff();
  }, []);

  return (
    <div className="white-container">
      <h3>Staff Registration Details </h3>
      <br />
      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>First Name</label>
            <Input
              placeholder="First Name"
              onChange={(e) => {
                set_first_name(e.target.value);
                clearError("name");
              }}
            />
            {errors?.name && (
              <>
                <span style={{ color: "red" }}>{errors?.name}</span>
              </>
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label>Last Name</label>
            <Input
              placeholder=" Last Name"
              onChange={(e) => {
                set_last_name(e.target.value);
                clearError("last_name");
              }}
            />
            {errors?.last_name && (
              <>
                <span style={{ color: "red" }}>{errors?.last_name}</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label htmlFor="email">
              Email <span style={{ color: "red" }}>*</span>
            </label>
            <Input
              id="email"
              autoComplete="new-password"
              placeholder="exampleABC@gmail.com"
              onChange={(e) => {
                const val = e.target.value;
                set_email(val);

                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (val && !emailRegex.test(val)) {
                  set_errors((prev) => ({
                    ...prev,
                    staff_email: "Please enter a valid email address.",
                  }));
                } else {
                  clearError("staff_email");
                }
              }}
            />
            {errors?.staff_email && (
              <span style={{ color: "red" }}>{errors?.staff_email}</span>
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label htmlFor="email"> Date of Birth</label>
            <Input
              type="date"
              id="date_of_birth"
              placeholder="date_of_birth"
              onChange={(e) => {
                set_date_of_birth(e.target.value);
              }}
            />
            {/* {errors?.email && (
              <span style={{ color: "red" }}>{errors?.email}</span>
            )} */}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>
              Password <span style={{ color: "red" }}>*</span>
            </label>
            <Input.Password
              autoComplete="new-password"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
              placeholder="Password"
              onChange={(e) => {
                set_password(e.target.value);
                clearError("staff_password");
              }}
            />
            {errors?.staff_password && (
              <span style={{ color: "red" }}>{errors?.staff_password}</span>
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label>
              {" "}
              Confirm Password <span style={{ color: "red" }}>*</span>
            </label>
            <Input.Password
              autoComplete="new-password"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
              placeholder=" Confirm Password"
              onChange={(e) => {
                set_confirm_password(e.target.value);
                clearError("confirm_password");
              }}
            />
            {errors?.confirm_password && (
              <span style={{ color: "red" }}>{errors?.confirm_password}</span>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label> Employee Id</label>
            <Input
              placeholder="Seafarer Id"
              onChange={(e) => {
                set_seafarer_id(e.target.value);
                clearError("seafarer_id");
              }}
            />
            {errors?.seafarer_id && (
              <span style={{ color: "red" }}>{errors?.seafarer_id}</span>
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label>Nationality</label>

            <CountryDropdown
              style={{ width: "100%", height: "32px" }}
              value={nationality}
              onChange={(value) => {
                set_nationality(value);
                clearError("nationality");
              }}
              className="ant-input css-dev-only-do-not-override-djtmh8 ant-input-outlined"
            />
            {errors?.nationality && (
              <span style={{ color: "red" }}>{errors?.nationality}</span>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>
              Rank <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              placeholder=" --- Select Designation --- "
              style={{ width: "100%" }}
              value={role_permission_id}
              onChange={(value) => {
                set_role_permission_id(value);
                clearError("role_permission_id");
              }}
            >
              {list_roll_permission?.length > 0 && (
                <>
                  {list_roll_permission.map((role) => (
                    <>
                      {role.status && !role.soft_delete && (
                        <>
                          <Select.Option
                            value={role.id}
                          >{` ${role.title}`}</Select.Option>
                        </>
                      )}
                    </>
                  ))}
                </>
              )}
            </Select>
            {errors?.role_permission_id && (
              <>
                <span style={{ color: "red" }}>
                  {errors?.role_permission_id}
                </span>
              </>
            )}

          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label>
              Please select ship <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              placeholder=" ---- Select Ship ---- "
              style={{ width: "100%" }}
              onChange={(value, ip_address) => {
                set_ship_id(value);
                clearError("ship_id");
              }}
            >
              {list_ship?.length > 0 && (
                <>
                  {list_ship.map((ship) => (
                    <>
                      {!ship.soft_delete && (
                        <>
                          <Select.Option
                            key={ship.id}
                            value={ship.id}
                            ip_address={ship.access_ip}
                          >
                            {ship.vessel_name}
                          </Select.Option>
                        </>
                      )}
                    </>
                  ))}
                </>
              )}
            </Select>
            {errors?.ship_id && (
              <span style={{ color: "red" }}>{errors?.ship_id}</span>
            )}
          </div>
        </div>

      </div>
      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>Department</label>
            <Select
              placeholder="--- Select Department ---"
              style={{ width: "100%" }}
              value={department}
              onChange={(value) => {
                setDepartment(value);
                clearError("department");
              }}
            >
              <Select.Option value="Deck">Deck</Select.Option>
              <Select.Option value="Engine">Engine</Select.Option>
            </Select>

            {errors?.department && (
              <span style={{ color: "red" }}>
                {errors?.department}
              </span>
            )}
          </div>
        </div>

        {(role_permission_id === 10 || role_permission_id === 13) && (
          <div className="col-6">
            <div className="input-box">
              <label>Security Code</label>
              <Input
                maxLength={6}
                value={securityCode}
                placeholder="Security Code"
                onChange={(e) => {
                  setSecurityCode(e.target.value);
                }}
              />

              {errorSecurity && (
                <span style={{ color: "red", fontSize: "11px" }}>
                  {errorSecurity}
                </span>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-4">
          <div className="input-box">
            <label>Sign On Date</label>
            <Input
              type="date"
              value={signOnDate}
              onChange={(e) => setSignOnDate(e.target.value)}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="input-box">
            <label>Expected Sign Off Date</label>
            <Input
              type="date"
              value={expectedSignOffDate}
              onChange={(e) => setExpectedSignOffDate(e.target.value)}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="input-box">
            <label>Actual Sign Off Date</label>
            <Input
              type="date"
              value={actualSignOffDate}
              onChange={(e) => setActualSignOffDate(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div
        style={{
          marginTop: "15px",
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={activeOvertime}
            onChange={(e) => setActiveOvertime(e.target.checked)}
            style={{
              width: "18px",
              height: "18px",
              cursor: "pointer",
            }}
          />

          <span>Enable Overtime</span>
        </label>
      </div>

      {activeOvertime && (
        <>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>
                  Currency <span style={{ color: "red" }}>*</span>
                </label>

                <CurrencyDropdown
                  value={currency}
                  onChange={setCurrency}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Base Salary</label>
                <Input
                  addonBefore={getCurrencySymbol(currency)}
                  placeholder="Base Salary"
                  onChange={(e) => {
                    setBase_salary(e.target.value);
                    clearError("Base Salary");
                  }}
                />
                {errors?.base_salary && (
                  <>
                    <span style={{ color: "red" }}>{errors?.base_salary}</span>
                  </>
                )}
              </div>
            </div>

            <div className="col-6">
              <div className="input-box">
                <label>Fixed Overtime Hours</label>
                <Input
                  addonBefore={getCurrencySymbol(currency)}
                  placeholder="Fixed Overtime Hours"
                  onChange={(e) => {
                    setFixed_overtime_hours(e.target.value);
                    clearError("Fixed Overtime Hours");
                  }}
                />
                {errors?.fixed_overtime_hours && (
                  <>
                    <span style={{ color: "red" }}>
                      {errors?.fixed_overtime_hours}
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Fixed Overtime Pay</label>
                <Input
                  addonBefore={getCurrencySymbol(currency)}
                  placeholder="Fixed Overtime Pay"
                  onChange={(e) => {
                    setfixed_overtime_pay(e.target.value);
                    clearError("Fixed Overtime Pay");
                  }}
                />
                {errors?.fixed_overtime_pay && (
                  <>
                    <span style={{ color: "red" }}>
                      {errors?.fixed_overtime_pay}
                    </span>
                  </>
                )}
              </div>
            </div>

            <div className="col-6">
              <div className="input-box">
                <label>Per Hour Overtime Pay</label>
                <Input
                  addonBefore={getCurrencySymbol(currency)}
                  placeholder="Per Hour Overtime Pay"
                  onChange={(e) => {
                    setPer_hour_overtime_pay(e.target.value);
                    clearError("Per Hour Overtime Pay");
                  }}
                />
                {errors?.per_hour_overtime_pay && (
                  <>
                    <span style={{ color: "red" }}>
                      {errors?.per_hour_overtime_pay}
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      <div style={{ marginTop: "40px", width: "100%" }}>
        <h3>Rank Default Schedule</h3>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(48, 1fr)",
            marginBottom: "4px",
            width: "100%",
          }}
        >
          {Array.from({ length: 24 }, (_, hour) => (
            <div
              key={hour}
              style={{
                gridColumn: "span 2",
                textAlign: "center",
                fontSize: "9px",
                fontWeight: "bold",
              }}
            >
              {hour}
            </div>
          ))}
        </div>

        <div
          onMouseUp={handleMouseUp}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(48, 1fr)",
            width: "100%",
            userSelect: "none",
            borderTop: "2px solid #555",
            borderBottom: "2px solid #555",
            borderLeft: "2px solid #555",
          }}
        >
          {Array.from({ length: 48 }, (_, index) => {
            const hour = Math.floor(index / 2);

            const label =
              index % 2 === 0
                ? `${hour}:00-${hour}:30`
                : `${hour}:30-${hour + 1}:00`;

            const isSelected = selectedSlots.includes(label);

            return (
              <div
                key={index}
                onMouseDown={() => handleMouseDown(label)}
                onMouseEnter={() => handleMouseEnter(label)}
                style={{
                  height: "22px",
                  background: isSelected ? "grey" : "white",
                  cursor: "pointer",
                  borderRight:
                    index % 2 === 0 ? "1px solid #ccc" : "2px solid #555",
                }}
              />
            );
          })}
        </div>
      </div>
      <br />

      <Button
        loading={loader}
        className="save_btn"
        onClick={Add_Ship_Staff}
        type="primary"
      >
        Save
      </Button>
    </div>
  );
}

export default AddStaff;
